module.exports = __webpack_public_path__ + "img/zizhi4.9a543a88.jpg";